import { UserOutlined } from "@ant-design/icons";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Avatar, Button, Divider, message } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { lCHarSVG } from "../../../assets/SVGs/SVGs";
import { addSale } from "../../../network/Sales";
import { getAvailableTeamMembersByServices } from "../../../network/teamMember";
import queryClient from "../../../services/react-query/queryClient";
import { availableTeamMember } from "../../../types/calendar";
import AddClient from "../../calendar/components/addAppointment/AddClient";
import DateAndTimePicker from "../../calendar/components/addAppointment/DateAndTimePicker";
import PaymentMethod from "../../calendar/components/addAppointment/PaymentMethod";
import Tax from "../../calendar/components/addAppointment/Tax";
import TotalPrice from "../../calendar/components/addAppointment/TotalPrice";
import ListGiftCard from "../ListGiftCard";
import ListServices from "../ListServices";
import ListSoldMembership from "../ListSoldMembership";
import ListSoldProducts from "../ListSoldProducts";
import SelectGiftCardSale from "../SelectGiftCardSale";
import SelectMembershipSale from "../SelectMembershipSale";
import SelectProductSale from "../SelectProductSale";
import SelectServiceSale from "../SelectServiceSale";
import LastStep from "./Items/LastStep";
type Props = { close: any };

const ModalQuickSale = ({ close }: Props) => {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [idSale, setIdSale] = useState<number | null>(null);
  const [products, setProducts] = useState<any>([]);
  const [services, setServices] = useState<any>([]);
  const [giftCards, setGiftCards] = useState<any>([]);
  const [memberships, setMemberships] = useState<any>([]);
  const [selectedTeamMember, setSelectedTeamMember] = useState<number | null>(
    null
  );
  const intl = useIntl();
  const [dateAndTime, setDateAndTime] = useState<any>({
    date: dayjs(), // Default to current date using Dayjs
    startTime: dayjs().format("HH:mm"), // Default start time set to current time, formatted to "HH:mm"
  });
  const [tax, setTax] = useState<null | {
    id: number;
    name: string;
    tax_rate: number;
  }>(null);
  const [clientData, setClientData] = useState<any | null>(null);
  const [paymentMethod, setPaymentMethod] = useState<number | null>(null);
  const { locationId } = useSelector((state: any) => state.calendar);
  const { mutate: onAddSale, isLoading: isAddingSale } = useMutation(addSale, {
    onSuccess: (res: any) => {
      queryClient.invalidateQueries(["sales"]);
      if (res?.code === "ERR_BAD_REQUEST" || res?.code === "ERR_BAD_RESPONSE") {
        message.error(res?.response?.data?.message);
      } else {
        message.success("تمت العملية بنجاح");
        setIdSale(res.data?.data?.id);
        setCurrentStep((step) => step + 1);
      }
    },
    onError: (error) => {
      console.log(error, "as");
      message.error("Failed to add salon. Please try again.");
    },
  });
  const ItemsSale: any = [];
  products.forEach((e: any) =>
    ItemsSale.push({
      itemable_id: e?.itemable_id,
      itemable_type: "product",
      quantity: e?.quantity,
    })
  );
  giftCards.forEach((e: any) =>
    ItemsSale.push({
      itemable_id: e?.itemable_id,
      itemable_type: "gift_card",
      quantity: e?.quantity,
    })
  );
  memberships.forEach((e: any) =>
    ItemsSale.push({
      itemable_id: e?.itemable_id,
      itemable_type: e?.itemable_type,
      quantity: e?.quantity,
    })
  );
  services.forEach((e: any) =>
    ItemsSale.push({
      itemable_id: e?.id,
      itemable_type: "pricing_option",
      team_member_id: e?.teamMemberId,
      quantity: 1,
    })
  );
  const AddSaleBody = {
    client_profile_id: clientData?.id,
    type: "all", //appointments,orders,memberships,gift_cards,all
    payment_method_id: paymentMethod, //cash, visa
    taxable_id: tax?.id,
    location_id: locationId,
    date: dayjs(dateAndTime?.date).format("YYYY-MM-DD"),
    // start_time: dateAndTime?.startTime,
    taxable_type: "tax",
    items: ItemsSale,
  };
  const { data: teamMembers } = useQuery(
    [
      "availableTeamMembers",
      services,
      dateAndTime,
      currentStep,
      clientData?.preferred_staff_gender!,
    ],

    () => {
      if (currentStep > 1 && currentStep < 4) {
        return getAvailableTeamMembersByServices({
          locationId: locationId,
          date: dayjs(dateAndTime?.date).format("YYYY-MM-DD"),
          start_time: dateAndTime?.startTime,
          pricing_option_ids: services.map((service: any) => service.id),
          available_for: "both",
          // available_for:
          //   clientPreferredGender === "female"
          //     ? "woman"
          //     : clientPreferredGender === "male"
          //     ? "man"
          //     : clientPreferredGender || "both",
        });
      }
      return { data: false };
    },
    { select: (res) => res?.data }
  );
  const buttonProps = (step: any) => {
    switch (step) {
      //   case 1:
      case 1:
        return {
          textId: "save",
          onClick: () => {
            if (!clientData) {
              message.error(
                "No client selected. Please select a client to proceed to the next step."
              );
              return;
            }
            if (services.length > 0) {
              if (!dateAndTime.date) {
                message.error("Please add a date for the service.");
                return;
              }
              if (!dateAndTime.startTime) {
                message.error("Please add a start time for the service.");
                return;
              }
            }
            setCurrentStep(step + 1);
          },
        };
      case 2:
        return {
          textId: "proceed_to_payment",
          onClick: () => {
            if (services.length) {
              if (!dateAndTime.date) {
                message.error("Please add a date for the service.");
                return;
              } else if (!dateAndTime.startTime) {
                message.error("Please add a start time for the service.");
                return;
              }
            }
            setCurrentStep(step + 1);
          },
        };
      case 3:
        return {
          textId: "confirm",
          onClick: () => setCurrentStep(step + 1),
        };
      case 4:
        return {
          textId: "done",
          onClick: () => {
            onAddSale(AddSaleBody);
          },
          //   loading: isAddingSalon,
        };
      default:
        return {
          textId: "save",
          onClick: () => {},
        };
    }
  };

  const { textId, onClick } = buttonProps(currentStep);

  const getTeamMembersOptions = (id: number, type: "service" | "package") => {
    if (!teamMembers?.length) {
      return [];
    }
    const filteredTeamMembers = teamMembers?.filter(
      (member: availableTeamMember) =>
        (type === "service" && member?.service_id?.includes(id)) ||
        (type === "package" && member?.package_id?.includes(id))
    );
    const temMembersOptions =
      filteredTeamMembers?.map((option: availableTeamMember) => {
        return {
          label: (
            <div className="flex items-center justify-between gap-2 px-2 ">
              <div className="flex items-center w-full gap-2">
                <Avatar
                  size={30}
                  src={option?.media}
                  className="bg-color-primary"
                  icon={<UserOutlined color="#fff" />}
                >
                  {option?.name?.charAt(0)}
                </Avatar>
                <p className="">{option?.name}</p>
              </div>
            </div>
          ),
          key: String(option?.id),
          value: String(option?.id),
        };
      }) || [];
    if (temMembersOptions.length > 0) {
      temMembersOptions.unshift({
        label: (
          <div className="flex items-center justify-between gap-2 px-2 ">
            <div className="flex items-center w-full gap-2">
              <Avatar size={30} className="bg-color-primary">
                {lCHarSVG}
              </Avatar>
              <p className="">
                {intl.formatMessage({
                  id: "lookfindrSuggestion",
                  defaultMessage: "إختيار لوكفايندر",
                })}
              </p>
            </div>
          </div>
        ),
        key: filteredTeamMembers[0]?.id,
        value: filteredTeamMembers[0]?.id,
      });
    }
    return temMembersOptions;
  };
  const handleSelectTeamMember = (
    id: number,
    teamMemberId: number | "lookfindr",
    type: "service" | "package"
  ) => {
    if (!teamMemberId) return;
    if (teamMemberId === "lookfindr") {
    }

    if (type === "service") {
      const newServices = services.map((service: any) => {
        if (service.id === id) {
          return {
            ...service,
            teamMemberId: +teamMemberId,
          };
        }
        return service;
      });
      setServices(newServices);
      return;
    }
  };
  return currentStep == 5 ? (
    <LastStep idSale={idSale} locationId={locationId} />
  ) : (
    <div>
      <div className="text-center">
        <h4 className="text-2xl font-semibold text-color-primary">
          <FormattedMessage id="addNewSaleTitle" />
        </h4>
        <p className="text-base text-[#75757E] mt-4">
          <FormattedMessage id="addNewSaleDescription" />
        </p>
      </div>
      <DateAndTimePicker
        dateAndTime={dateAndTime}
        setDateAndTime={setDateAndTime}
        step={currentStep}
      />
      <div className="flex items-center justify-center w-full gap-4 mt-8">
        <AddClient setClientData={setClientData} clientData={setClientData} />
      </div>
      <Divider />
      {currentStep === 1 ? (
        <div className="grid w-full grid-cols-2 gap-4 mb-4">
          <SelectProductSale products={products} setProducts={setProducts} />
          <SelectServiceSale services={services} setServices={setServices} />
          <SelectGiftCardSale giftCard={giftCards} setGiftCard={setGiftCards} />
          <SelectMembershipSale
            memberships={memberships}
            setMemberships={setMemberships}
          />
        </div>
      ) : null}
      <div className="grid w-full grid-cols-2 gap-4 text-sm">
        <ListSoldProducts
          products={products}
          setProducts={setProducts}
          currentStep={currentStep}
        />
        <ListServices
          handleSelectTeamMember={handleSelectTeamMember}
          currentStep={currentStep}
          getTeamMembersOptions={getTeamMembersOptions}
          services={services}
          setServices={setServices}
        />
        <ListGiftCard giftCard={giftCards} setGiftCard={setGiftCards} />
        <ListSoldMembership
          memberships={memberships}
          setMemberships={setMemberships}
          currentStep={currentStep}
        />
      </div>
      {currentStep > 1 && (
        <>
          <Divider className="bg-color-primary" />
          <div className="mb-4">
            <Tax setTax={setTax} tax={tax} />
          </div>
          <TotalPrice
            products={products}
            services={services}
            giftCard={giftCards}
            memberships={memberships}
            tax={tax}
          />
          {currentStep > 2 && (
            <PaymentMethod
              isSelectedPaymentMethod={currentStep >= 4}
              paymentMethod={paymentMethod}
              setPaymentMethod={setPaymentMethod}
            />
          )}
        </>
      )}{" "}
      <div className="flex items-center w-full gap-2 mt-8">
        <Button
          type="primary"
          className="w-full"
          htmlType="submit"
          disabled={
            products.length === 0 ||
            services.length === 0 ||
            memberships.length === 0 ||
            giftCards.length === 0
          }
          loading={isAddingSale}
          onClick={onClick}
        >
          {intl.formatMessage({ id: textId })}
        </Button>

        <Button
          type="primary"
          onClick={close}
          className="w-full btn-primary-not"
          htmlType="button"
        >
          {intl.formatMessage({ id: "cancel" })}
        </Button>
      </div>
    </div>
  );
};

export default ModalQuickSale;
